import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function MapRefCapture({ mapRef, onMapReady }) {
  const map = useMap();
  useEffect(() => {
    if (mapRef) mapRef.current = map;
    onMapReady?.(map);
    return () => {
      try {
        if (typeof map.stop === 'function') map.stop();
      } catch (_) { /* ignore */ }
      if (mapRef && mapRef.current === map) mapRef.current = null;
    };
  }, [map, mapRef, onMapReady]);
  return null;
}
